module.exports = __webpack_public_path__ + "img/OS0025.ae9f7dd.jpg";